export class SideNavHeaderConfig {
    title: string;
    subtitle: string;
    picture: string;
}
